"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorSchema = exports.ResponseSchema = exports.BodySchema = exports.method = exports.path = exports.action = void 0;
exports.parseBody = parseBody;
exports.resp_success = resp_success;
exports.resp_err = resp_err;
const zod_1 = require("zod");
const common_1 = require("../../../../common");
exports.action = 'signin';
exports.path = 'signin';
exports.method = common_1.HttpMethod.POST;
// #region Request
exports.BodySchema = zod_1.z.object({
  email: common_1.BasicEmail.nullable(),
  password: common_1.BasicLegacyMinimumPassword,
  audience: common_1.BasicAudience.optional()
});
function parseBody(dto) {
  return exports.BodySchema.parse(dto);
}
// #endregion
// #region Response
exports.ResponseSchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  slug: zod_1.z.string(),
  access: zod_1.z.string(),
  refresh: zod_1.z.string()
});
function resp_success(dto) {
  return exports.ResponseSchema.parse(dto);
}
exports.ErrorSchema = zod_1.z.object({
  error: zod_1.z.string()
});
function resp_err(dto) {
  return exports.ErrorSchema.parse(dto);
}
// #endregion
